export default __webpack_public_path__ + "static/media/Screenshot_3.b64eb6e0.png";